<template>
  <div>
    <AlertBannerRecords class="mt-4" path="/vehicles" :message="vehiclesMessage" />
    <AlertBannerRecords class="mt-4" path="/maestro/chronotachographs" :message="scheduleMessage" />
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa, Renavam ou Protocolo"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
    
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query" @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgesFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Empresas</label>
          <Select2 :options="filterCnpjs" v-model="query.cnpj"/>
        </div>

        <div class="col-md-4">
          <label>Status do documento</label>
          <Select2 :options="filterDocumentStatus" v-model="query.documentStatus"/>
        </div>

        <div class="col-md-4">
          <label>Status do Cronotacógrafo</label>
          <Select2 :options="filterSituation" v-model="query.situation"/>
        </div>

      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>Status do Veículo</label>
          <select v-model="query.entityStatusId" class="browser-default custom-select">
            <option
              v-for="opt in (filterEntityStatusId ? filterEntityStatusId.table : [])"
              :key="opt.value" :value="opt.value"
            >{{ opt.label }}</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="valid_at">Data de vencimento</option>
            <option value="issued_at">Data de emissão</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          v-if="$withPolicy('cm-crono', 'consult')"
          class="btn btn-primary mt-1 mr-1"
          @click="showModal = true"
          >
          Consulta avulsa
        </button>

        <Dropdown
            v-if="$withPolicy('cm-crono', 'download_xlsx')"
            title-dropdown="Exportar"
            class="btn btn-primary mt-1 mr-1"
            :enable="someChronotachographSelected"
        >
          <ul>
            <li>
              <ul>
                <li class="bkps-dropdown-item ml-2" @click="toXLSX()">
                  Cronotacógrafo
                </li>
                <li class="bkps-dropdown-item ml-2" @click="toXLSX(true)">
                  Cronotacógrafo + Dados Adicionais do Veículo
                </li>
              </ul>
            </li>
          </ul>

        </Dropdown>

        <template v-if="$withPolicy('cm-crono', 'consult_history')">
          <router-link
              tag="button"
              to="/cm-crono/consultas"
              class="btn btn-primary mt-1 mr-1"
          >
            Histórico de consultas
          </router-link>
        </template>

        <template v-if="getUser.brobotStaff">
          <router-link
              tag="button"
              to="/cm-crono/configuracoes"
              class="btn btn-primary mt-1 mr-1"
          >
            Configurações
          </router-link>
        </template>

      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong>
          {{ infoTotalModels }}
          <template v-if="meta.lastConsult">
            Última consulta realizada em: {{ meta.lastConsult | datetime }}
          </template>
        </strong>

        <button class="btn btn-outline ml-3 mb-1"
                v-if="chronotachographs.length > 0"
                @click="changeCheck({checkAll: !checkAll, sources: chronotachographs})"
                :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <Table
          :chronotachographs="chronotachographs"
          :entity-status-names="entityStatusNames"
          @changeCheckAllRow="changeCheckAllRow"
          @changeCheckRow="changeCheckRow"
          @fetchChronotachographs="asyncTemplateSelect({ pagination: true })"
          :check-all-row="checkAllRow"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>
    
    <VehicleRequestModal v-model="showModal" appName="cm-crono" width="lg"/>
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Formatter from '@/models/Formatter'
  import CheckedModels from '@/mixins/CheckedModels'
  import Dropdown from '../shares/specialTag/Dropdown.vue'

  import GetAccount from '@/mixins/GetAccount.vue'
  import GetUser from '@/mixins/GetUser.vue'
  import ModelMapper from '@/mixins/ModelMapper'
  import VehicleRequestModal from '../vehicles/VehicleRequestModal'

  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import Table from '@/components/cm-crono/Table'
  import handleSearchable from '@/models/handleSearchable'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  import AlertBannerRecords from '@/components/shares/AlertBannerRecords.vue';
  import { VEHICLE_STATUS, VEHICLE_STATUS_OPTIONS, VEHICLE_STATUS_FILTER_TABLE } from '@/utils/vehicleStatus'
  import { cronoSituationFilterTable } from '@/utils/cronoSituation'

  export default {
    components: {
      AlertBannerRecords,
      BadgeFilters, ChevronDownIcon, Dropdown,
      VehicleRequestModal, Pagination,
      SearchIcon, Select2, Table
    },
    computed: {
      badgesFilters() {
        return [
          this.filterDocumentStatus,
          this.filterCnpjs,
          this.filterSituation,
          this.filterStatus,
          this.filterEndDate,
          this.filterStartDate,
          this.filterEnable,
          this.filterEntityStatusId,
        ]
      },
      someChronotachographSelected() {
        return this.checkAll || this.chronotachographs.some(chronotachograph => chronotachograph.checked)
      },
      chronotachographs() {
        return this.getModels || []
      },
    },
    created() {
      this.addOrderBy('updatedAt')
      this.methods = ['vehicles']
      this.$set(this.query, 'periodType', 'updated_at')
      this.$set(this.query, 'enable', '')
      this.$set(this.query, 'entityStatusId', String(VEHICLE_STATUS.ENABLED))
      this.defaultModelSetting.updateQueryURL = true

      this.asyncTemplateSelect({
        byURL: true,
        pagination: true,
        finish: () => this.loadFilters()
      })

      this.loadEntityStatus()
    },
    data: () => ({
      filterCnpjs: null,
      filterSituation: null,
      filterDocumentStatus: null,
      filterEntityStatusId: null,
      entityStatusNames: {},
      filterEnable: new Filter({
        key: 'enable',
        label: 'Ativo',
        table: [
          ['Todos', ''],
          ['Sim', 'true'],
          ['Não', 'false'],
        ],
      }),
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      vehiclesMessage: 'Ainda não existem veículos cadastrados no sistema. <a href="/definitions?tab=vehicles">Clique aqui</a> para ir para o cadastro de veículos.',
      scheduleMessage: 'Ainda não existem cronotacógrafos registrados no sistema. <a href="/cm-crono/configuracoes">Clique aqui</a> para ir para o agendamento de consultas.',
      modelPathPrefix: 'maestro',
      nameModel: 'Chronotachograph',
      showFilter: false,
      showModal: false,
      vehicles: [],

    }),
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        if (this.query.cnpj)
          this.query.cnpj = handleSearchable(this.query.cnpj)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.chronotachographs })
      },
      changeCheckRow(){
        this.changeCheck({ sources: this.chronotachographs })
      },
      find() {
        this.asyncTemplateSelect()
      },
      loadEntityStatus() {
        this.entityStatusNames = VEHICLE_STATUS_OPTIONS.reduce((map, s) => {
          map[s.id] = s.friendlyName
          return map
        }, {})

        this.filterEntityStatusId = new Filter({
          key: 'entityStatusId',
          label: 'Status do Veículo',
          type: 'select',
          table: VEHICLE_STATUS_FILTER_TABLE
        })
      },
      async loadFilters() {
        const methods = [
          this.loadCompanies,
          this.loadDocumentStatus,
          this.loadSituation,
        ]

        for (const method of methods)
          await method()
      },
      loadCompanies() {
        const params = {
          q: {
            type: ['parent', 'subsidiary'],
            meta: false,
            per_page: 10000
          }
        }

        return this.axios.get('/companies', { params })
          .then(response => response.data)
          .then((companies) => this.buildFilterCnpj(companies))
      },
      buildFilterCnpj(companies) {
        const cnpjs = companies.map(company => [
          company.name + ' - ' + Formatter.cnpj(company.cnpj),
          company.cnpj
        ])

        this.filterCnpjs = new Filter({
          key: 'cnpj',
          label: 'CNPJ',
          table: cnpjs
        })
      },
      loadDocumentStatus() {
        return this.axios.get('/maestro/chronotachographs/fetch_column/document_status')
          .then(response => {
            this.filterDocumentStatus = new Filter({
              key: 'documentStatus',
              label: 'Status',
              table: response.data
            })
          })
      },
      loadSituation() {
        return this.axios.get('/maestro/chronotachographs/fetch_column/situation')
          .then(response => {
            this.filterSituation = new Filter({
              key: 'situation',
              label: 'Status do Cronotacógrafo',
              table: cronoSituationFilterTable(response.data)
            })
          })
      },
      toXLSX(withVehicle) {
        let params = this.checkAll ?
          this.buildParams() :
          { q: { id: this.chronotachographs.filter(c => c.checked).map(c => c.id) } }

        if (withVehicle)
          params['methods'] = ['vehicles']

        this.openLoad()
        this.axios.get('maestro/chronotachographs/report', { params })
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
            else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
    },
    mixins: [ModelMapper, CheckedModels, GetAccount, GetUser],
    name: 'Index',
    watch: {
      chronotachographs(newValue, oldValue) {
        if (newValue !== oldValue)
          this.changeCheck({checkAllRow: false})
      }
    }
  }

</script>

<style scoped>

</style>
